import { ChevronDownIcon } from '@heroicons/react/24/outline';
import React, { useEffect, useRef, useState } from 'react';
import { SaveCancelByIconButtons } from './SaveCancelByIconButtons';
import { OverlayGrayBackground } from './OverlayGrayBackground';

export const ValueSelect = ({
    options,
    selectClassName,
    productEDT,
    createNew, 
    onSelect,
    isLoading,
    label
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [showAddingEDT, setShowAddingEDT] = useState(false);
    const [dropdownStyles, setDropdownStyles] = useState({});
    const [inputValue, setInputValue] = useState("");
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const updatePosition = () => {
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                setDropdownStyles({
                    top: `${rect.bottom}px`,
                    left: `${rect.left}px`,
                    width: `${rect.width}px`,
                });
            }
        };
        if (!isOpen) {
            setShowAddingEDT(false)
        }
        if (isOpen) {
            updatePosition();
            window.addEventListener('scroll', updatePosition, true);
            window.addEventListener('resize', updatePosition);
        }
        return () => {
            window.removeEventListener('scroll', updatePosition, true);
            window.removeEventListener('resize', updatePosition);
        };
    }, [isOpen]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className={`relative inline-block ${selectClassName}`}ref={dropdownRef}>
            <button
                ref={buttonRef}
                disabled={isLoading}
                onClick={() => setIsOpen((prev) => !prev)}
                title={`${label || ""}${productEDT}`}
                className="flex items-center justify-between gap-1 w-full bg-white border border-gray-300 rounded shadow-sm px-2 py-1 text-sm text-gray-700 hover:bg-gray-50"
            >
                <span className='text-ellipsis overflow-hidden'>{label || ""}{productEDT}</span>
                <ChevronDownIcon className="h-4 w-4" />
            </button>
            {isOpen && (
                <div 
                    className='bg-white border border-gray-300 rounded-md shadow-lg text-xs fixed z-50 '
                    style={dropdownStyles}
                >
                    {isLoading && <OverlayGrayBackground />}
                    <div
                        className="max-h-48 overflow-auto"
                    >
                        <ul
                            aria-disabled={isLoading}
                        >
                            {options.map((value, index) => (
                                <li
                                    key={`${value}-${index}`}
                                    onClick={() => {
                                        onSelect(value);
                                        setIsOpen(false);
                                    }}
                                    className={`cursor-pointer px-2 py-1 hover:bg-gray-100 hover:text-black text-left ${value === productEDT ? "bg-blue-600 text-white" : ""}`}
                                >
                                    {label || ""}{value}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        {!showAddingEDT && (
                            <button
                                onClick={() => setShowAddingEDT(true)}
                                className="flex w-full justify-center cursor-pointer px-2 py-1 text-blue-600 hover:bg-blue-50 border-t border-gray-200"
                            >
                                Add new
                            </button>
                        )}
                        {showAddingEDT && (
                            <div
                                className="flex h-[60px] justify-center flex-col cursor-pointer px-1 py-1 text-blue-600 border-gray-200 bg-white border-gray-300 rounded-md shadow-lg"
                            >
                                <input 
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                    className='py-0.5 px-1 shadow-sm border border-gray-300 rounded-md shadow-sm text-sm h-auto'
                                />
                                <div className='h-[25px]'>
                                    <SaveCancelByIconButtons
                                        onSaveClick={async () => {
                                            createNew(inputValue);
                                            setInputValue("");
                                        }}
                                        onCancelClick={() => setShowAddingEDT(false)}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
